import React from 'react';
interface InputProps {
  label?: string;
  type?: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  error?: string;
  disabled?: boolean;
  multiline?: boolean;
  rows?: number;
  maxLength?: number;
  showCharCount?: boolean;
}
export function Input({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  onFocus,
  onBlur,
  error,
  disabled = false,
  multiline = false,
  rows = 3,
  maxLength,
  showCharCount = false
}: InputProps) {
  const baseStyles = 'w-full px-4 py-3 bg-white border rounded-ios text-charcoal placeholder-moss-gray focus:outline-none focus:ring-2 focus:ring-dark-green focus:border-transparent transition-all';
  const errorStyles = error ? 'border-red-500' : 'border-sand';
  const disabledStyles = disabled ? 'opacity-50 cursor-not-allowed' : '';
  const handleChange = (newValue: string) => {
    if (maxLength && newValue.length > maxLength) {
      return;
    }
    onChange(newValue);
  };
  const charCount = value.length;
  const isNearLimit = maxLength && charCount >= maxLength * 0.9;
  const isAtLimit = maxLength && charCount >= maxLength;
  return <div className="w-full" data-id="element-341">
      <div className="flex items-center justify-between mb-2" data-id="element-342">
        {label && <label className="block text-sm font-medium text-charcoal" data-id="element-343">
            {label}
          </label>}
        {showCharCount && maxLength && <span className={`text-xs ${isAtLimit ? 'text-red-500 font-medium' : isNearLimit ? 'text-clay' : 'text-moss-gray'}`} data-id="element-344">
            {charCount}/{maxLength}
          </span>}
      </div>

      {multiline ? <textarea value={value} onChange={e => handleChange(e.target.value)} onFocus={onFocus} onBlur={onBlur} placeholder={placeholder} disabled={disabled} rows={rows} maxLength={maxLength} className={`${baseStyles} ${errorStyles} ${disabledStyles} resize-none`} data-id="element-345" /> : <input type={type} value={value} onChange={e => handleChange(e.target.value)} onFocus={onFocus} onBlur={onBlur} placeholder={placeholder} disabled={disabled} maxLength={maxLength} className={`${baseStyles} ${errorStyles} ${disabledStyles}`} data-id="element-346" />}

      {error && <p className="mt-1 text-sm text-red-500" data-id="element-347">{error}</p>}
    </div>;
}